/** @format */

import { useEffect, useState, useMemo } from "react";
import { gymsGet, gymsGetKey } from "../data/ApiEndpoints";
import { useSelector } from "react-redux";
import { selectToken } from "../components/auth/auth.selector";
import { useGetFetch } from "../data/Queries";

const useGymsData = () => {
  const token = useSelector(selectToken);
  const {
    data: gymsData,
    isLoading,
    isFetching,
    refetch,
    error,
  } = useGetFetch({
    url: gymsGet,
    key: gymsGetKey,
    token,
  });
  const [gyms, setGyms] = useState({
    data: [],
    isLoading,
    isFetching,
    refetch,
    error,
  });

  useEffect(() => {
    try {
      if (gymsData) {
        const { data, status } = gymsData;

        if (status) {
          const mappedGyms = data?.map((gym) => ({
            label: gym?.gym_name,
            value: gym?.user_id,
          }));

          if (mappedGyms) {
            setGyms({
              data: mappedGyms,
              isLoading,
              isFetching,
              refetch,
              error,
            });
          }
        }
      }
    } catch (error) {
      console.error("Error processing gym data:", error);
    }
  }, [gymsData]);

  const memoizedGyms = useMemo(() => gyms, [gyms]);

  return memoizedGyms;
};

export default useGymsData;
